import { useNavigate, useParams } from "react-router-dom";
import { useAppContext } from "../../../../../AppContext";
import { useApiQuery } from "../../../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../../../common/infrastructure/routes/endpointsMetadata";
import { PageMode } from "../../../../../common/types";
import { IMyFamilyWizardFormModel } from "../models/myFamilyWizardFormModel";
import { useMyFamilyWizardForm } from "./useMyFamilyWizardForm";
import { SubmitHandler } from "react-hook-form";
import { useApiMutation } from "../../../../../common/infrastructure/hooks/useApiMutation";
import {
  routePaths,
} from "../../../../../common/infrastructure/routes/routePaths";

export const useMyFamilyWizardPage = (pageMode: PageMode) => {
  const { familyId } = useParams();
  const navigate = useNavigate();
  const { isDesktopOrTablet } = useAppContext();
  const { mutateAsync } = useApiMutation();
  const pageTitle = `${
    pageMode === "add" ? "Създаване на вашето" : "Редактиране на"
  } семейство`;

  const { data: familyData, isLoading } = useApiQuery<IMyFamilyWizardFormModel>(
    {
      queryKey: [endpointsMetadata.myFamily.wizardGetFamilyData, familyId],
      endpoint: `${endpointsMetadata.myFamily.wizardGetFamilyData}?familyId=${
        familyId ?? 0
      }`,

      globalIsLoading: true,
    }
  );

  const form = useMyFamilyWizardForm(familyData);

  const handleSubmit: SubmitHandler<IMyFamilyWizardFormModel> = async (
    data
  ) => {
    try {
      await mutateAsync(
        {
          endpoint: endpointsMetadata.myFamily.updateFamily,
          globalIsLoading: false,
          method: "post",
          invalidateKeys: [[endpointsMetadata.myFamily.getCurrentUserFamily]],
          ...data,
        },
        {
          onSuccess: () => {
            navigate(routePaths.portalMyFamily);
          },
        }
      );
    } catch {}
  };

  return {
    familyData,
    form,
    isDesktopOrTablet,
    isLoading,
    pageTitle,
    handleSubmit,
    navigate,
  };
};
